






import {
    Component,
    Prop,
    Vue,
    Question,
    ComponentStyle,
    ComponentStyleDefinition,
} from "@zoovu/runner-browser-api";

@Component({})
export default class QuestionValidationMessageView extends Vue {

    @Prop()
    question: Question;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

}
